import { useState, useEffect } from 'react'
import { getNormativeConfig } from '../services/normativeConfigService'

/**
 * Hook: useNormativeConfig
 *
 * Fetches the normative config (TABLA_TOPES + RENTAS_AUTONOMOS) from Firestore.
 * The underlying service always returns usable data — it falls back to hardcoded
 * values from normativaDictamen.js when Firestore is unavailable.
 *
 * Returns: { config: { topes, rentas } | null, loading, error, source }
 */
export default function useNormativeConfig() {
  const [config, setConfig] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [source, setSource] = useState('pending')

  useEffect(() => {
    let active = true
    getNormativeConfig().then((result) => {
      if (!active) return
      setConfig(result.data)
      setSource(result.source)
      setLoading(false)
      if (!result.success) {
        setError(result.error?.message || 'Failed to fetch from Firestore, using fallback')
      }
    })
    return () => { active = false }
  }, [])

  return { config, loading, error, source }
}
